export default __webpack_public_path__ + "static/media/61.5b4f43ea.jpg";